<h3 class="heading heading-summary m-b-20 m-t-0-force">{{journey | MMSTranslate}}</h3>
<section class="ps-timeline-sec">
    <ol class="ps-timeline">
        <li *ngFor="let stageItem of stageList; let index = index;"
            [style.width]="stageList ? 100/stageList.length +'%' : '15%'">
            <div [ngClass]="index % 2 === 0 ? 'img-handler-top' : 'img-handler-bot' "
                [class.expandCard]="stageItem.isExpanded" [class.cur-pointer]="stageItem.workflowData"
                (click)="expandStageTimelineCard(index)" clickOutside
                (clickOutside)="closeStageTimelineCard(index)">
                <!-- <img [src]="'/assets/images/ico/'+stageItem.status+'.png'" alt=""/> -->
                <div class="stageCardDataSec">
                    <div class="stageCardTitle" [ngClass]="{'highlightStage' : workQueueItem.stageCd == stageItem.lookupKey}">{{stageItem.lookupValue}}</div>
                </div>
                <!-- <div> -->
                    <div class="stageCardData" *ngIf="stageItem.workflowData && stageItem.isExpanded">
                        <p *ngIf="stageItem.workflowData?.taskUser">Assignee : {{stageItem.workflowData?.taskUser | technicalTranslate}}</p>
                        <p *ngIf="stageItem.workflowData?.startDt">Start Date & Time : {{stageItem.workflowData?.startDt
                            | date:'dd-MM-yy HH:mm:ss'}}</p>
                        <p *ngIf="stageItem.workflowData?.endDt">End Date & Time : {{stageItem.workflowData?.endDt |
                            date:'dd-MM-yy HH:mm:ss'}}</p>
                        <p *ngIf="stageItem.workflowData?.startDt && stageItem.workflowData?.endDt">
                            Completed in (TAT) :
                            {{getDayDifference(stageItem.workflowData.startDt,stageItem.workflowData.endDt)}}
                        </p>
                        <p *ngIf="workQueueItem && workQueueItem.submissionModeCd">
                            Source : {{workQueueItem.submissionModeCd == 'PAPER' ? 'Paper' : workQueueItem.submissionModeCd}}
                          </p>
                    </div>
                <!-- </div> -->
            </div>
            <!-- <div [ngClass]="index % 2 === 0 ? 'ps-bot' : 'ps-top' "> -->
            <!-- <p [class.cur-pointer]="stageItem.status =='completed' || stageItem.status == 'active'"><b>{{stageItem.lookupValue}} -->
            <!-- <p><b>{{stageItem.lookupValue}}  </b></p> -->
            <!-- </div> -->
            <!-- <span [ngClass]="index % 2 === 0 ? 'ps-sp-top' : 'ps-sp-bot' " [ngClass]="stageItem.status == 'active' ? 'blob green' : ''">{{index+1}}</span> -->
            <span *ngIf="workQueueItem"
                [ngClass]="{'ps-sp-top': index % 2 === 0, 'ps-sp-bot': workQueueItem.stageCd == stageItem.lookupKey, 'blob green' : workQueueItem.stageCd == stageItem.lookupKey, 'pending-cases' : currentStage < stageItem.sortOrder}">
                <img *ngIf="stageItem.lookupKey;else showDefaultIcon"
                    [src]="'/assets/images/ico/'+stageItem.lookupKey.toLowerCase()+'.png'" alt="" />
                <ng-template #showDefaultIcon><img [src]="'/assets/images/ico/pendingde.png'" alt="" /></ng-template>
            </span>
        </li>
        <!-- <li>
                    <div class="img-handler-bot">
                        <img src="https://cdn-icons-png.flaticon.com/128/4157/4157035.png" alt=""/>
                    </div>
                    <div style="padding-left:80px;" class="ps-top">
                        <p> <b>PreAuth Approval</b></p>
                    </div>
                    <span class="ps-sp-bot">02</span>
                </li> -->

    </ol>
</section>